import {
  KnowledgeBaseCreateModel,
  KnowledgeBaseListModel,
  KnowledgeBaseListQueryModel,
  KnowledgeBaseRecordModel,
} from "@/api/models/knowledge-bases";
import {
  GetKnowledgeBaseList200,
  KnowledgeBase,
  GetKnowledgeBaseListParams,
  NameCount,
} from "@/api/services";
import {ManagementTransformBase} from "@/api/transform/TranformBase";

export class KnowledgeBasesTransform extends ManagementTransformBase<KnowledgeBaseRecordModel> {
  public makeRecordModel(dto: NameCount): KnowledgeBaseRecordModel {
    const model: KnowledgeBaseRecordModel = {
      name: dto.name,
      slug: dto.slug,
      searchInstructions: "",
      items: {count: dto.items_count},
    };

    return model;
  }

  public makeListModel(dto: GetKnowledgeBaseList200): KnowledgeBaseListModel {
    const model: KnowledgeBaseListModel = {
      records: dto.items.map(item => this.makeRecordModel(item as NameCount)),
      pagination: this.makePaginationModel(dto),
    };

    return model;
  }

  public makeListQueryDto(
    model: KnowledgeBaseListQueryModel,
  ): GetKnowledgeBaseListParams {
    return {
      page_number: model.current,
      page_size: model.size,
      workspace_id: model.workspace.id,
    };
  }

  public makeCreateDto(model: KnowledgeBaseCreateModel): {data: KnowledgeBase} {
    const dto: KnowledgeBase = {
      name: model.name,
      search_instructions: model.searchInstructions,
      workspace_id: model.workspace.id,
    };

    return {data: dto};
  }
}

export const knowledgeBasesTransform = new KnowledgeBasesTransform();
